var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 220,
    viewBox: "0 0 330 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 220,
    rx: 16,
    fill: "url(#paint0_radial_3129_9033)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3129_9033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186 164) rotate(-73.9901) scale(183.102 274.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285181,
    stopColor: "#68717A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454409,
    stopColor: "#6C7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583067,
    stopColor: "#797C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874769,
    stopColor: "#7F8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970582,
    stopColor: "#6C7279"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground6);
export default __webpack_public_path__ + "static/media/background_6.6c45d9dc73071f8b3a37934edcbb8a35.svg";
export { ForwardRef as ReactComponent };